<template>
    <div>
        <div class="box"></div>
        <div class="content">
            <div class="lef">
                <div>智慧住建平台产品</div>
                <p>
                    <a class="don">· 智慧住建管理平台</a>
                </p>
            </div>
            <div class="small-page">
                <div class="top-title">智慧住建管理平台</div>
                <div class="img">
                    <img src="./img/live/1.jpg">
                </div>
                <div class="text-content">
                    智慧住建管理平台，重在强化信息管理、提升服务水平，搭建“一平台、两体系、三系统、四库”总体框架，以智慧统筹住房城乡建设发展，推进基础设施智能化、行业管理精细化、公共服务便捷化、办公系统自动化，实现“监管职能的再监督，服务水平的再提升。
                </div>
                <div class="text-content">
                    “一平台”即“智慧住建”一体化平台；“两体系”即硬件基础设施体系、应用软件支撑体系；“三系统”即政务协同办公系统、GIS地理信息管理系统、业务管理系统；“四库”建设即项目库、企业库、人员库、诚信库建设及与办公平台一体化应用。
                </div>
                <div class="img">
                    <img src="./img/live/2.jpg">
                    <p>指挥中心</p>
                </div>
                <div class="text-content">
                    将安全指挥中心、监控系统以及住建信息化平台进行统一构建和管理，推进“智慧工地”建设，对施工工地进行统一管理、随时监控、集中调度，确保工程质量和文明施工。
                </div>
                <div class="left-title" style="margin-top: .5rem">产品价值</div>
                <div class="text-content">
                    <div class="point">1+N联动，信息高效管理：<span>实时上传各称重站过磅数据，减少人为干预，提高数据采集的准确性、实时性，避免作弊情况的发生。</span></div>
                    <div class="point">自动预警，多重报表分析：<span>分级分类预警，系统自动生成业务报表、分析图表和周期性报告，无需手动操作，减少人工干预。</span></div>
                    <div class="point">技防代替人防，智慧化监管：<span>施工现场智慧化监管，围绕“人机料法环”五大生产要素，线下业务线上办理，政企联动，实现政府有监管、企业有落实、项目部有应用。</span></div>
                    <div class="point">多方服务，提升政府形象：<span>互联网+政务服务，数据多跑腿，群众少跑腿，深化“最多跑一次”。</span></div>
                    <div class="point">安全文明生产管理：<span>提供从开工备案、安全交底、过程检查、整改闭环、标化考评等全流程管理。提供环境监测、裸土未覆盖、垃圾乱堆放、车辆未冲洗、安全帽有无佩戴等文明施工管理。</span></div>
                    <div class="point">行为管理：<span>提供管理人员出勤统计、建筑工人实名制和分账制管理，包括出工记录、工资发放、培训记录、诚信记录等，并依据现场行为联动市场监管，实时汇总诚信评价记录。</span></div>
                    <div class="point">质量管理：<span>提供从监督注册、质量交底、过程检查、整改闭环、不合格台账处理等全流程管理。</span></div>
                    <div class="point">GIS地图综合监管：<span>以大屏看板设计为基础，集成在建工程地图分布查询功能，根据报警级别显示不同颜色；通过与视频、企业库、人员库、质量、安全、行为等信息衔接，实现GIS地图综合信息分析和监管。</span></div>
                    <div class="point">建筑市场管理：<span>通过对建筑市场主体行为、工程建设项目流程的动态监管，对辖区内建筑市场行业管理、信用管理、工程项目过程管理，建立企业库、人员库、项目库和信用库四大数据库，实现建筑市场与现场的联动综合监管。</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            idx: '0',
        }
    },
}
</script>

<style lang="scss" scoped>
.box {
    height: 2.9rem;
    width: 100%;
    background: url('./img/banner/5.png');
    background-size: 100% 100%;
}

.box2 {
    width: 10rem;
    margin: 0.34rem auto 0.6rem;
    text-align: center;

    a {
        text-decoration: none;
    }

    .el-menu-item {
        width: 2rem;
        font-size: 0.2rem;
        height: 0.72rem;
        line-height: 0.72rem;
    }

    .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: 3px solid #e70f20;
        color: #e70f20;
    }

    .el-menu--horizontal > .el-menu-item {
        color: #000;
    }
}

.box3 {
    width: 12rem;
    margin: 0 auto;

    .main {
        cursor: pointer;
        height: 2.2rem;
        background: #fbfbfb;
        display: flex;
        position: relative;
        margin-bottom: 0.3rem;

        img.lef {
            width: 3.6rem;
            height: 2.2rem;
        }

        div {
            height: 1.6rem;
            margin: 0.3rem 0 0 0.57rem;

            p.tit {
                font-size: 0.26rem;
            }

            p.txt {
                width: 6.5rem;
                font-size: 0.18rem;
                color: #595757;
                line-height: 0.36rem;
                text-align: justify;
                margin-top: 0.23rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
            }
        }

        span {
            position: absolute;
            width: 0.38rem;
            height: 0.38rem;
            background: url('../../assets/images/more.png');
            background-size: 100% 100%;
            right: 0.32rem;
            bottom: 0.35rem;
            cursor: pointer;
        }
    }
}

.content {
    width: 12rem;
    margin: 0.5rem auto 0;
    display: flex;

    .lef {
        margin-right: 0.24rem;
        width: 2.2rem;
        overflow: hidden;
        div {
            font-size: 0.2rem;
            position: relative;
            padding-left: 0.1rem;
            margin-bottom: 0.19rem;
        }

        div::before {
            position: absolute;
            content: '';
            left: 0rem;
            top: 0.06rem;
            background: #e70f20;
            width: 2px;
            height: 0.16rem;
        }

        p {
            line-height: 0.34rem;
            font-size: 0.16rem;
            width: 1.76rem;
            color: #3f3f3f;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: pointer;

            a {
                display: inline-block;
                width: 100%;
            }
        }

        .don {
            color: #e70f20;
        }
    }
}

.small-page {
    flex: 1;

    .top-title {
        margin-bottom: 0.15rem;
        text-align: center;
        font-size: 0.26rem;
    }

    .left-title {
        font-size: 0.22rem;
        margin-bottom: 0.1rem;
    }

    .text-content {
        margin-bottom: 0.1rem;
        font-size: 0.18rem;
        color: #595757;
        line-height: 0.36rem;

        .point {
            padding-left: 0.1rem;
            position: relative;
            line-height: 0.36rem;
            color: #484848;

            span {
                color: #595757;
                font-weight: normal;
            }

            &:before {
                left: 0;
                top: 0.18rem;
                margin-top: -0.03rem;
                position: absolute;
                width: 0.06rem;
                height: 0.06rem;
                border-radius: 50%;
                content: ' ';
                background: #484848;
            }
        }
    }

    .img {
        text-align: center;

        img {
            margin: 0.2rem 0;
            width: 80%;
        }
    }
}
</style>
